import { Component, OnInit, Inject, OnChanges } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { FormControl } from '@angular/forms';
import { ApiEndpoints } from './../../../shared/services/api-endpoints.service';

@Component({
  selector: 'app-welcome-dialog',
  templateUrl: './welcome-dialog.component.html',
  styleUrls: ['./welcome-dialog.component.scss'],
})
export class WelcomeDialogComponent implements OnInit {
  public welcomeForm: FormGroup;
  private agentInfo: any;
  private agentAgencyName: any;
  private companyPlaceholder: String;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<WelcomeDialogComponent>,
    private fb: FormBuilder,
    private apiEndpoint: ApiEndpoints,
  ) {}

  ngOnInit() {
    this.agentInfo = this.data.agentInfo;
    this.agentAgencyName = this.data.agentAgencyName;
    this.companyPlaceholder = this.agentInfo.firstName
      ? this.agentInfo.firstName + ' ' + this.agentInfo.lastName + "'s company"
      : 'Your Company Name';
    this.welcomeForm = new FormGroup({
      companyName: new FormControl('', []),
      phoneNumber: new FormControl('', []),
      companyMembers: new FormControl('', []),
    });
    if (this.checkPhoneNumber(this.agentInfo.mobileNumber)) {
      if (this.agentInfo.mobileNumber.indexOf('+1') == -1) {
        this.welcomeForm.controls['phoneNumber'].setValue(
          this.agentInfo.mobileNumber,
        );
      } else {
        this.welcomeForm.controls['phoneNumber'].setValue(
          this.agentInfo.mobileNumber.substring(2),
        );
      }
    }
  }

  checkPhoneNumber = value => {
    var check = new RegExp(/^\+1\d{1,10}$/);
    var res = check.test(value);
    return res;
  };

  SendAgentInfo() {
    var data = {
      phone_number: this.welcomeForm.value.phoneNumber,
      number_of_employees: this.welcomeForm.value.companyMembers,
      email: this.agentInfo.email,
      company: this.welcomeForm.value.companyName,
    };
    this.apiEndpoint.post('agentwelcomePopupForm', data).subscribe(data => {});
    this.dialogRef.close();
  }
}
